// Licensed under Gnu Public Licence version 2
// Copyright (c) 2020-23 (original work) Open Assessment Technologies SA ;

import { generateElementId } from '../dom/dom.js';

/**
 * Create options array
 * @param {Array | Object} optionProps
 * Supports 2 formats of options:
 * - object of key:label pairs
 * - array of objects with 'key' & 'label' keys
 * @returns {Array} in the following format: [ { key: 'key1', label: 'Label 1', id: 'tao-option' } ]
 */
export default function normalizeOptions(optionProps) {
    let array;
    if (typeof optionProps === 'object' && !Array.isArray(optionProps)) {
        array = Object.keys(optionProps).map(key => ({
            key,
            label: optionProps[key],
            id: generateElementId('option')
        }));
    } else {
        array = optionProps.map(option =>
            Object.assign({}, option, {
                label: option.label,
                id: generateElementId('option')
            })
        );
    }
    return array;
}
